var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRlefLogoMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1346_22176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.84096 5.87446C8.97616 5.87446 9.10491 5.82296 9.21113 5.73605C10.6435 4.51931 12.5008 3.78219 14.5223 3.78219C16.3023 3.78219 17.989 4.33906 19.4118 5.39485C20.165 5.95172 21.2176 5.9485 21.8968 5.3015C22.7691 4.47103 22.6596 3.10301 21.739 2.41095C19.6435 0.833693 17.1489 0 14.5223 0C10.5244 0 6.98044 1.96674 4.79804 4.97961C4.52765 5.353 4.79804 5.87446 5.26156 5.87446H8.84096Z",
    fill: "url(#paint0_linear_1346_22176)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0158 7.96023C30.2593 7.2392 29.0619 7.26495 28.3409 8.02139C27.9611 8.41731 27.2465 9.31216 26.0169 10.8572C24.0984 13.2682 20.886 17.2982 19.6306 18.3089C18.401 19.2971 16.9332 20.2145 14.5254 20.2145C12.1177 20.2145 9.97716 19.1845 8.47394 17.5461C8.3645 17.427 8.21321 17.3561 8.05226 17.3561H4.75935C4.31836 17.3561 4.04154 17.839 4.2733 18.2156C6.38167 21.6791 10.1896 23.9967 14.5287 23.9967C18.137 23.9967 20.4192 22.5321 22.0061 21.2542C23.4675 20.0761 26.0297 16.9152 28.9814 13.2102C29.8763 12.0868 30.8033 10.9216 31.0834 10.6287C31.8044 9.87224 31.7787 8.67482 31.0222 7.95379L31.0158 7.96023Z",
    fill: "url(#paint1_linear_1346_22176)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6375 13.0294C46.9924 10.5229 45.2482 8.20326 42.7417 7.84832C40.2352 7.49338 37.9156 9.23756 37.5606 11.7441C37.2057 14.2506 38.9499 16.5702 41.4564 16.9252C43.9629 17.2801 46.2825 15.5359 46.6375 13.0294Z",
    fill: "#004047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9633 18.1222C38.8281 18.1222 38.6994 18.1737 38.5931 18.2606C37.1607 19.4773 35.3034 20.2145 33.282 20.2145C31.5019 20.2145 29.8152 19.6576 28.3925 18.6018C27.6393 18.0449 26.5867 18.0482 25.9075 18.6952C25.0352 19.5256 25.1446 20.8937 26.0652 21.5857C28.1607 23.163 30.6554 23.9999 33.282 23.9999C37.2798 23.9999 40.8238 22.0331 43.0062 19.0203C43.2766 18.6469 43.0062 18.1254 42.5427 18.1254H38.9633V18.1222Z",
    fill: "url(#paint2_linear_1346_22176)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7883 16.0365C17.5448 16.7575 18.7422 16.7318 19.4632 15.9753C19.843 15.5794 20.5576 14.6846 21.7873 13.1395C23.7057 10.7285 26.9182 6.6985 28.1735 5.68777C29.4031 4.69957 30.8709 3.78219 33.2787 3.78219C35.6864 3.78219 37.827 4.81223 39.3302 6.45065C39.4396 6.56974 39.5909 6.64056 39.7518 6.64056H43.0448C43.4857 6.64056 43.7626 6.15773 43.5308 5.78112C41.4224 2.3176 37.6145 0 33.2754 0C29.6671 0 27.3849 1.46459 25.798 2.74249C24.3366 3.9206 21.7744 7.08155 18.8227 10.7865C17.9278 11.9099 17.0008 13.0751 16.7207 13.368C15.9997 14.1245 16.0254 15.3219 16.7819 16.0429L16.7883 16.0365Z",
    fill: "url(#paint3_linear_1346_22176)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.15642 16.9925C5.0105 14.6266 3.08883 12.705 0.719727 11.5558C3.08561 10.4099 5.00728 8.48824 6.15642 6.11914C7.30234 8.48502 9.22402 10.4067 11.5931 11.5558C9.22723 12.7018 7.30556 14.6234 6.15642 16.9925Z",
    fill: "#008D9C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1346_22176",
    x1: 4.69182,
    y1: 2.93562,
    x2: 22.4955,
    y2: 2.93562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008D9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1346_22176",
    x1: 4.18317,
    y1: 15.7177,
    x2: 31.6016,
    y2: 15.7177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004047"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1346_22176",
    x1: 43.1124,
    y1: 21.061,
    x2: 25.3088,
    y2: 21.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004047"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1346_22176",
    x1: 45.9321,
    y1: 8.27897,
    x2: 18.5136,
    y2: 8.27897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008D9C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1346_22176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.5605,
    height: 24,
    fill: "white",
    transform: "translate(0.719727)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRlefLogoMark);
export default __webpack_public_path__ + "static/media/RLEF-Logo-Mark.4fb25d6154c2bf0608adb2d15dfa4326.svg";
export { ForwardRef as ReactComponent };